export class SoilMoisture {
    public soilMoisturePercentage: number;
    public soilMoistureIndex: string;
}
